/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

export type EnvProperty =
    | "KEYCLOAK_REALM"
    | "KEYCLOAK_HOST"
    | "KEYCLOAK_CLIENT_ID"
    | "INVALID_LICENSE_URL"
    | "LICENCE_WILL_EXPIRE_AFTER_DAYS"
    | "SHOP_URL"
    | "HMDB_URL"

interface Env {
    KEYCLOAK_REALM: string
    KEYCLOAK_HOST: string
    KEYCLOAK_CLIENT_ID: string
    INVALID_LICENSE_URL: string
    LICENCE_WILL_EXPIRE_AFTER_DAYS: string
    SHOP_URL: string
    HMDB_URL: string
}

const env = (property: EnvProperty): string => {
    // eslint-disable-next-line
    const __ENV: Env = (window as any).__ENV as Env
    return __ENV[property]
}

export default env
